import { inputs } from "../../../../inputs/inputConfigs";
import PointOfContactSelect from "./PointOfContactSelect";

export default () => {
  return {
    groups: [
      {
        items: [
          {
            input: {
              InputComponent: PointOfContactSelect,
              name: "pointOfContacts",
            },
            grid: { xs: 12 },
          },
        ],
      },
      {
        items: [
          {
            input: {
              ...inputs.remitAddressLabel,
            },
            grid: { xs: 12 },
          },
          {
            input: {
              ...inputs.locationName,
              label: "Payee Name",
              required: true,
            },
            grid: { xs: 12 },
          },
          {
            input: {
              ...inputs.location,
              required: true,
            },
            grid: { xs: 12 },
          },
          {
            input: inputs.locationAddress2,
            grid: { xs: 12 },
          },
          {
            input: {
              ...inputs.locationCity,
              required: true,
            },
            grid: { xs: 6 },
          },
          {
            input: {
              ...inputs.locationState,
              required: true,
            },
            grid: { xs: 6 },
          },
          {
            input: {
              ...inputs.locationCountry,
              required: true,
            },
            grid: { xs: 6 },
          },
          {
            input: {
              ...inputs.locationPostalCode,
              required: true,
            },
            grid: { xs: 6 },
          },
        ],
      },
    ],
  };
};
